import { useLocation } from 'react-router-dom'
import { useGetTyposQuery } from '../api/v2/typo'
import { useMyContext } from '../context/context'
import useSettingsV2 from './useSettingsV2'

const useConfOffline = () => {
  const location = useLocation()
  const { myContext } = useMyContext()
  const { settings } = useSettingsV2()

  const { data: typosV2 } = useGetTyposQuery(myContext)

  const typoIdPath = location.pathname.split('/')[1].split('+')[1]
  const typo = typosV2?.find(f => f.id === Number(typoIdPath))
  const typoSettings = typo ? settings?.typosV2?.[typo.id] : {}

  const LOGIN_HTML = typoSettings?.homeMessage || settings?.homeMessage

  return { LOGIN_HTML, typo }
}

export default useConfOffline
